// extracted by mini-css-extract-plugin
export default {"container":"ActualTopicCard_container__DIZcV","main":"ActualTopicCard_main__THuD5"};